import { type FC, useEffect, useRef } from 'react';
import posthog from 'posthog-js';

import { getFullName } from '@/common/lib/getFullName';
import { useAppSelector } from '@/redux/store';

const PostHogIdentificator: FC = () => {
  const userId = useAppSelector((state) => state.user.user?.id);
  const inviterId = useAppSelector((state) => state.user.user?.inviterId);
  const firstName = useAppSelector((state) => state.user.user?.firstName);
  const lastName = useAppSelector((state) => state.user.user?.lastName);
  const userName = useAppSelector((state) => state.user.user?.userName);
  const level = useAppSelector((state) => state.user.user?.level);
  const referral = useAppSelector((state) => state.user.user?.referral);
  const identifiedRef = useRef(false);

  useEffect(() => {
    if (userId && !identifiedRef.current) {
      identifiedRef.current = true;
      posthog.identify(userId, {
        ...(inviterId && { inviter_id: inviterId }),
      });
    }
  }, [userId, inviterId]);

  useEffect(() => {
    if (!userId || !identifiedRef.current) return;

    const name = getFullName({ firstName, lastName, userName });
    posthog.setPersonProperties({
      ...(name && { name }),
      ...(level !== undefined && { level }),
      ...(referral && { referral }),
    });
  }, [userId, firstName, lastName, userName, level, referral]);

  return null;
};

export { PostHogIdentificator };
